<template>
  <div
    v-motion
    :initial="computedInitial"
    :animate="{ opacity: 1, x: 0, y: 0 }"
    :transition="transitionConfig"
    :whileHover="props.hover"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

type Orientation = "x" | "y" | "none";

// 1. Removed 'class' from props because Vue handles attribute fallthrough automatically
const props = withDefaults(
  defineProps<{
    orientation?: Orientation;
    offset?: number;
    hover?: Record<string, any>;
    // You can also add custom delay or duration props here later if you want!
    delay?: number;
  }>(),
  {
    orientation: "y",
    offset: 80,
    delay: 0,
  }
);

// 2. Compute the initial state based on orientation and offset
const computedInitial = computed(() => {
  const base = { opacity: 0 };

  if (props.orientation === "x") {
    return { ...base, x: props.offset, y: 0 };
  }

  if (props.orientation === "y") {
    return { ...base, y: props.offset, x: 0 };
  }

  return base;
});

// 3. Define the transition config.  animate values are static (opacity 1, x 0, y 0).
const transitionConfig = computed(() => ({
  type: "spring",
  stiffness: 140,
  damping: 18,
  mass: 1.8,
  delay: props.delay, // Extracted to a prop for max reusability!
}));
</script>
